import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { Subject, Observable } from "rxjs";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupNotificationData {
  public title: string;
  public time: number;
  public actions: Array<{
    label: string;
    command: BfxPopupNotificationCommand;
    icon: string;
    styleClass: string;
    /**If true, then we add a separator - could augment in future*/
    separatorBefore?: boolean;
  }>;
  public body: string;
  public bodyMultiple: string;
  public bodyType: string;
  public footer: string;
  public footerAction: BfxPopupNotificationCommand;
  public closeAction: BfxPopupNotificationCommand;
  public typeStr: string;
  public payload: Array<any> = [];
  public payloadIds: Array<string> = [];

  // Replacement for typeStr for constructing the body of grouped messages in case typeStr should not be used for the body label
  public bodyMultipleId: string;

  // Show the time in the notification even when grouped
  public showTime: boolean = false;

  // Body is the full witdth of the notification when grouped
  public fullBodyWidth: boolean = false;

  // Callback to be invoked after notification data
  public updateActionCallback: (notificationData: BfxPopupNotificationData) => void;

  // Flag that needs to be turned on if the notification should invoke the update action callback, off by default
  protected supportActionCallback: boolean = false;

  private notifPopupCommandSubject: Subject<{
    command: BfxPopupNotificationCommand;
    popupData: BfxPopupNotificationData;
    selectedItemId?: string;
  }> = new Subject<{
    command: BfxPopupNotificationCommand;
    popupData: BfxPopupNotificationData;
    selectedItemId?: string;
  }>();

  constructor(
    public type: BFXNotificationType,
    public iconClassName: string = "icon-notification",
    public subType: BFXNotificationSubType = undefined,
    public idField = "orderId",
  ) {
    this.typeStr = BFXNotificationType[type];
    if (subType != undefined) {
      this.typeStr += "_" + BFXNotificationSubType[subType];
    }
  }

  subscribeForCommand(): Observable<{
    command: BfxPopupNotificationCommand;
    popupData: BfxPopupNotificationData;
  }> {
    return this.notifPopupCommandSubject.asObservable();
  }

  destroy() {
    this.payload = null;
    this.payloadIds = null;
    this.notifPopupCommandSubject.complete();
  }

  doAction(command: BfxPopupNotificationCommand, itemId?: string): void {
    if (itemId) {
      let itemIndex: number = this.payloadIds.indexOf(itemId.toString());
      if (itemIndex > 0) {
        let tempItem: string = this.payloadIds[0];
        this.payloadIds[0] = itemId.toString();
        this.payloadIds[itemIndex] = tempItem;
      }
    }
    this.notifPopupCommandSubject.next({
      command: command,
      popupData: this,
      selectedItemId: itemId,
    });
  }

  addToPayload(item: any) {
    if (this.payloadIds.indexOf(item[this.idField]) == -1) {
      this.payload = [...this.payload, item];
      this.payloadIds = [...this.payloadIds, item[this.idField]];
      this.updateActions();
    }
  }

  removeFromPayload(itemId: any) {
    let idx: number = this.payload.findIndex((item) => item[this.idField] === itemId);
    if (idx > -1) {
      this.payload.splice(idx, 1);
      this.updateActions();
    }
    idx = this.payloadIds.indexOf(itemId);
    if (idx > -1) {
      this.payloadIds.splice(idx, 1);
    }
  }

  protected updateActions(): void {
    this.updateAllowableActions();

    if (this.supportActionCallback === true && this.updateActionCallback != null) {
      try {
        this.updateActionCallback(this);
      } catch (e) {
        logger.out.error(
          this.constructor.name + ": Error while invoking update action callback",
          e,
        );
      }
    }
  }

  protected updateAllowableActions() {
    // default is no actions
  }
}
